module.exports = __webpack_public_path__ + "img/home_yoga.fb1c8e52.jpg";